<template>
<div class="live-course-container">
  <!-- 加载页面 -->
  <div class="loading-page-wrapper" v-if="info.state==0||pageLoading==1||pageLoading==2" @touchmove.prevent.stop="()=>{}">
    <div class="loading-page">
      <div class="loading-ccom" v-if="pageLoading==1">
        <van-loading type="spinner" color="#ed5b68" vertical>加载中...</van-loading>
      </div>
      <div class="empty-ccom" v-if="pageLoading==2||info.state==0">
        <van-icon name="coupon-o" />
        <span v-if="info.state==0">该课程已下架</span>
        <span v-else class="no-data">未获取到数据,请点击 <b @click="reloadPage"  v-track="{ name: 'reloadPage'}">刷新</b>重试 </span>
      </div>
    </div>
  </div>
  <!-- 加载页面 -->
  <div class="real-conent" v-if="info._id&&!(pageLoading==1||pageLoading==2)&&info.state!=0">
    <!--头部下载-->
    <download-top></download-top>
    <!-- <div class="download-head">
      <img src="../../assets/course/logo_7net.png" alt="">
      <van-button class="download-button" round color="#ed5b68" @click="toDownload">下载</van-button>
    </div> -->
    <!--头部下载-->

    <!-- banner图 -->
    <div class="banner-pic">
      <vanImage width="100%" height="100%" :src="info.picture||info.pictureBig||require('../../assets/course/banner.png')" fit="cover"></vanImage>
    </div>
    <!-- banner图 -->

    <!-- 主体部分 -->
    <div class="main-content">
      <!-- 课程信息 -->
      <div class="lesson-meta">
        <div class="lesson-meta-inner">
          <h3 class="name">{{info.title||'暂无数据'}}</h3>
          <div class="time-price">
            <p class="time">{{info.startTime||'暂无开始时间'}}-{{info.endTime||'暂无结束时间'}}</p>
            <p class="free" v-if="!showPrice">免费</p>
            <p class="topprice" v-else>
              <span class="newPrice">￥{{info.price||info.priceAndroid||0}}/</span>
              <span class="oldPrice">￥{{info.originalPrice||0}}</span>
            </p>
          </div>
          <div class="lesson-label" v-if="info.tags.length>0">
            <span v-for="(item,index) in info.tags" :key="index">{{item}}</span>
          </div>
        </div>

      </div>
      <!-- 课程信息 -->
      <!-- 老师信息 -->
      <div class="teacher-info" v-if="info.liveChapterList.length>0&&isShowTeacher">
        <div class="teacher-info-inner">
          <p class="teacher-label">主讲老师</p>
          <div class="teacher-detail">
            <div class="teacher-avatar">
              <img :src="getTeacher.techerHead||require('../../assets/course/avatar_default.png')" alt="">
              <span>{{getTeacher.techerName}}</span>

              <div class="upcounts">
                <i class="iconfont icon-like01"></i>
                <span>{{getFirstChapterZan|filterNumber}}</span>
              </div>
            </div>
            <div class="teacher-desc">
              <p>
                {{getDescStr}}
                <span v-if="showExpend" @click="expendedDesc" v-track="{ name: 'expendedDesc'}">展开</span>
              </p>
            </div>
          </div>

        </div>
        <!-- 老师信息 -->
      </div>
      <!-- tab切换 -->
      <vanTabs line-width="10px" :border="false" title-active-color="#ed5b68" :sticky="true" swipeable>
        <vanTab title="课程详情">
          <!-- <div class="gridant"></div> -->
          <div class="tab-inner detail-tab" style="min-height:100px" v-html="getContent"></div>
        </vanTab>
        <vanTab title="系列课" v-if="info.liveChapterList&&info.liveChapterList.length>1">
          <div class="gridant"></div>
          <div class="tab-inner" style="min-height:100px">
            <div class="list chapter-list">
              <chapter v-for="(item,index) in info.liveChapterList" :key="index" :info="item" @todownload="toDownload">

              </chapter>
            </div>
          </div>

        </vanTab>
        <vanTab title="课程评价">
          <div class="gridant"></div>
          <div class="tab-inner" style="min-height:100px">
            <div class="list commentList" v-if="commentList.length>0">
              <comment v-for="(item,index) in commentList" :key="index" :info="item"></comment>

              <van-pagination v-model="currentPage" :total-items="totalComment" :items-per-page="10" @change="handlePageChange" />
            </div>
            <div class="loading-page" v-else style="background-color:transparent;height:100px;">
              <div class="loading-ccom" v-if="commentLoading">
                <van-loading type="spinner" color="#ed5b68" vertical>加载中...</van-loading>
              </div>

              <div class="empty-ccom" v-if="!commentLoading&&commentList.length<=0">
                <van-icon name="coupon-o" />
                <span>暂无评论</span>
              </div>
            </div>
          </div>
        </vanTab>
      </vanTabs>
      <!-- tab切换 -->
    </div>
    <!-- 主体部分 -->

    <!-- 底部按钮 -->
    <div class="bottom-button">
      <div class="button-price">
        <span v-if="!showPrice" class="free">免费</span>
        <p class="price" v-if="showPrice">
          <span class="newPrice">￥{{info.price||info.priceAndroid||0}}/</span>
          <span class="oldPrice">￥{{info.originalPrice||0}}</span>
        </p>
      </div>
      <van-button class="button-enter" @click="handleBuy" :loading="buyLoading"  v-track="{ name: 'expendedDesc'}">
        <p>{{getBuyStr}}</p>
        <p v-if="(info.isBuy==0||info.isBuy==6||info.isBuy==8||info.isBuy==5)&&info.isCharge">{{info.buyCount|filterNumber}}人已{{info.isCharge?`购买`:`预约`}}</p>
        <p v-if="(info.isBuy==0||info.isBuy==6||info.isBuy==8||info.isBuy==5)&&!info.isCharge">{{info.subscribeCount|filterNumber}}人已{{info.isCharge?`购买`:`预约`}}</p>
        <p v-if="(info.isBuy==7||info.isBuy==9||info.isBuy==10)">{{info.playBackCount|filterNumber}}人已回看</p>
      </van-button>
    </div>
    <!-- 底部按钮 -->
  </div>

  <!-- 信息通知弹框 -->
  <van-dialog v-model="showMessage" :show-confirm-button="false" :show-cancel-button="false" closeOnClickOverlay>
    <div class="messageDialog">
      <p class="message">{{messageForm.msg}}</p>
      <div class="downBtn">
        <van-button round @click="toDownload"  v-track="{ name: 'to_show'}">
          前往App观看直播
        </van-button>
      </div>
    </div>
  </van-dialog>
  <!-- 信息通知弹框 -->
</div>
</template>

<script>
import Button from 'vant/lib/button'
import 'vant/lib/button/style'
import Image from 'vant/lib/image'
import 'vant/lib/image/style'
import Tab from 'vant/lib/tab'
import 'vant/lib/tab/style'
import Tabs from 'vant/lib/tabs'
import 'vant/lib/tabs/style'
import Dialog from 'vant/lib/dialog'
import 'vant/lib/dialog/style'
import Loading from 'vant/lib/loading'
import 'vant/lib/loading/style'
import CellGroup from 'vant/lib/cell-group'
import 'vant/lib/cell-group/style'
import Field from 'vant/lib/field'
import 'vant/lib/field/style'
import Toast from 'vant/lib/toast'
import 'vant/lib/toast/style'
import Icon from 'vant/lib/icon'
import 'vant/lib/icon/style'
import Pagination from 'vant/lib/pagination'
import 'vant/lib/pagination/style'
import comment from './components/Coment'
import chapter from './components/Chapter'

import DownloadTop from '@/components/DownloadTop'

import { api_courseInfoDetails, api_courseCommentList, api_courselChapter, api_courseSubscribe } from '@/api/course'
import OrderMixins from '@/mixins/order' //订单相关公用方法

export default {
  name: 'LiveCourse',
  components: {
    DownloadTop,
    vanImage: Image,
    vanTab: Tab,
    vanTabs: Tabs,
    comment,
    vanCellGroup: CellGroup,
    vanField: Field,
    vanButton: Button,
    vanDialog: Dialog.Component,
    vanLoading: Loading,
    vanIcon: Icon,
    chapter,
    vanPagination: Pagination
  },
  mixins: [OrderMixins],
  filters: {
    filterNumber(num) {
      if (num > 1000000) {
        return 100 + '万+'
      }
      if (num > 10000) {
        return (num / 10000).toFixed(2) + '万'
      }
      return num
    }
  },
  data() {
    return {
      showMessage: false,
      messageForm: {
        btnText: '',
        msg: ''
      },
      currentPage: 1,
      expanded: false,
      verifyToken: '',
      pageLoading: 1, //1加载中 2获取数据出错
      guid: '',
      info: {},
      time: 60,
      totalComment: 0,
      commentList: [],
      commentLoading: false,
      buyLoading: false,
      payCode: '',
      getPayResultTime: 0,
      baseUrl: '',
      descStr: '教育学硕士、历史学博士、省政府津贴专家华中师范大学测量与评价测量与评价研究专家华中师范大学测量与评价测量与评价研究中心主任，文学院教授，博士研究中心主任，文学专家华中师范大学测量与评价测量与评价研究中心主任，文学院教授，博士研究中心主任，文学专家华中师范大学测量与评价测量与评价研究中心主任，文学院教授，博士研究中心主任，文学专家华中师范大学测量与评价测量与评价研究中心主任，文学院教授，博士研究中心主任，文学专家华中师范大学测量与评价测量与评价研究中心主任，文学院教授，博士研究中心主任，文学中心主任，文学院教授，博士研究中心主任，文学院教授，博士生导师。多年从事教育考试工作，曾任湖北省教育考试院高考命题中心主任、高考办主任，主持和参与多轮高考、学考改革方案设计起草与实施。',
    }
  },
  watch: {
    payLoading: {
      deep: true,
      handler(newVal) {
        // 若为false则说明订单状态请求完成，此时更新用户信息
        if (!newVal) this.getData()
      }
    }
  },
  computed: {
    userToken: {
      get() {
        return this.$store.state.token
      }
    },
    showPrice () {
      if (!this.info.isCharge) {
        return false
      }
      return true
    },
    showExpend () {
      if (this.descStr.length>109&&!this.expanded) return true
      return false
    },
    getDescStr () {
      if (this.descStr.length>109&&!this.expanded){ return this.descStr.slice(0,105)+'...'}
      return this.descStr
    },
    getContent () {
      let str= '';
      if (this.info.content){
        this.info.content.forEach(it=>{
          str+=it.content
        })
      }
      return str;
    },
    isShowTeacher () {

        if (!this.info.liveChapterList) return false;
        if (this.info.liveChapterList.length<=0) return false;
        if (this.info.liveChapterList.length>1) return false;
        let teacherName = this.info.liveChapterList[0].cptTeacher.techerName
        if (this.info.liveChapterList.every((it)=>it.cptTeacher.techerName==teacherName)){
          return true;
        }
        return false
    },
    getTeacher () {
      if (!this.info.liveChapterList) return {};
      if (this.info.liveChapterList[0]){
        return this.info.liveChapterList[0].cptTeacher
      }
      return {}
    },
    getFirstChapterZan () {
      if (!this.info.liveChapterList) return 0;
      if (this.info.liveChapterList[0]){
        return this.info.liveChapterList[0].cptPraiseCount
      }
      return 0
    },
    getBuyStr () {
      // 0：未购买；1：参团中；2：可观看；3：直播中；4：立即听课；5：未预约；6：已预约；7：回看；8：未购买已直播中
      let dict = {
        '0':'立即购买',
        '1':'参团中',
        '2':'立即观看',
        '3':'直播中',
        '4':'立即听课',
        '5':'预约',
        '6':'已预约',
        '7':'回看',
        '8':'立即购买',
        '9':'立即购买',
        '10':'回看'
      }
      let type = this.info.isBuy
      return dict[type]
    }
  },
  created() {
    this.$track('start_liveCourse', { courseGuid: this.guid })
    this.$store.dispatch('share/initShareParams')
    this.guid = this.$route.query.courseGuid
    if (this.guid) {
      this.getData()
    } else {
      this.pageLoading = 2
    }
  },
  methods: {
    getData() {
      api_courseInfoDetails({
        courseGuid: this.guid
      }).then((res) => {
          if (res.status == 200) {
            this.info = res.data
            this.$set(this, 'info', res.data)
            if (res.data.title) {
              this.setTitle(res.data.title, res.data.intro, res.data.picture)
            }
            if (this.info.liveChapterList) {
              if (this.info.liveChapterList[0]) {
                this.descStr = this.info.liveChapterList[0].cptTeacher.techerSummary
              }
            } else {
              this.descStr = ''
            }
            this.getComment()
            let courseGuid = this.guid
            this.getLiveChapterList(courseGuid)
              .then(() => {
                this.pageLoading = 0
              })
              .catch(() => {
                this.pageLoading = 2
              })
          }
        })
        .catch((err) => {
          this.pageLoading = 2
          Toast(err.message || '请求出错');
        })
    },
    handleBuy() {
      switch (this.info.isBuy) {
        case 0:
          // 判断有没有登录
          if (!this.userToken) {
            this.$router.push('/login')
          } else {
            // 创建订单
            this.toBuyLesson()
          }
          break;
        case 1:
          Toast('本课程您已参团,请看看其他课程吧');
          break;
        case 2:
          this.toDownload()
          break;
        case 3:
          this.toDownload()
          break;
        case 4:
          this.toDownload()
          break;
        case 5:
          // 判断有没有登录
          if (!this.userToken) {
            this.$router.push('/login')
          } else {
            // 预约
            this.USubscribe()
          }
          break;
        case 6:
          this.alertMessage('该课程已预约，可在七天学堂【已购买课程中】观看直播哦')
          break;
        case 7:
          this.$track('click_liveCourse_lookback', { courseGuid: this.guid })
          this.toDownload()
          break;
        case 8:
          // 判断有没有登录
          if (!this.userToken) {
            this.$router.push('/login')
          } else {
            // 创建订单
            this.toBuyLesson()
          }
          break;

        case 9:
          // 判断有没有登录
          if (!this.userToken) {
            this.$router.push('/login')
          } else {
            // 创建订单
            this.toBuyLesson()
          }
          break;
        case 10:
          this.toDownload()
          break;

        default:
          break;
      }
    },
    getComment() {
      let courseGuid = this.guid
      this.commentLoading = true
      let start = this.currentPage - 1
      api_courseCommentList({
        courseGuid,
        start
      }).then(data => {
        this.commentList = data.data.list
        this.totalComment = data.data.total
        this.commentLoading = false
      }).catch(() => {
        this.commentLoading = false
      })
    },
    getLiveChapterList(courseGuid) {
      return api_courselChapter({
        courseGuid
      }).then(data => {
        if (data.data.liveChapterList) {
          this.$set(this.info, 'liveChapterList', data.data.liveChapterList)
          if (data.data.liveChapterList[0]) {
            this.descStr = data.data.liveChapterList[0].cptTeacher.techerSummary
          }
        }
        return data;
      })
    },
    // 预约
    USubscribe() {
      let resourceGuid = this.guid
      let source = 3
      this.buyLoading = true
      this.$track('click_liveCourse_subscribe', { courseGuid: this.guid })
      api_courseSubscribe({
        resourceGuid,
        source
      }).then(() => {
        this.alertMessage('报名成功，可在七天学堂【已购买课程中】观看直播哦')
        this.info.isBuy = 6
        this.showMessage = true
        this.buyLoading = false
      }).catch(err => {
        this.buyLoading = false
        if (err.status == 401) {
          this.logOut()
        }
        Toast(err.message || '预约失败')
      })
    },
    // 购买
    toBuyLesson() {
      let param = {
        source: 3,
        ordertype: this.info.type == 5 ? 5 : 0,
        resources: JSON.stringify([{
          resourceId: this.guid,
          number: 1
        }])
      }
      this.buyLoading = true
      this.$track('click_liveCourse_buy', { courseGuid: this.guid })
      // 创建订单
      this.$createOrder(param).finally(() => {
        this.buyLoading = false
      })
    },
    handlePageChange(page) {
      this.currentPage = page
      this.getComment()
    },
    alertMessage(msg) {
      this.messageForm.msg = msg
      this.showMessage = true
    },
    expendedDesc() {
      this.expanded = true
    },
    toDownload() {
      this.$router.push({
        path: '/download',
        query: {
          courseGuid: this.guid
        }
      })
    },
    setTitle(title, desc, imgUrl) {
      this.$store.dispatch('share/initShareParams', {
        title: title,
        desc: desc,
        imgUrl: imgUrl
      })
    },
    reloadPage() {
      window.location.reload(true)
    }
  }
}
</script>

<style lang="scss" scoped>
    .live-course-container{
      width: 100%;
      min-height: 100%;
      padding-top: 48px;
      position: relative;
      .chapter-list{
        padding:0 16px;
      }
      .commentList{
        .van-pagination{

          ::v-deep .van-pagination__item{
            color:#fe7172;
          }
          ::v-deep .van-pagination__item--active{
            background-color:#fe7172;
            color:#fff;
          }
        }
      }
      .real-conent{
        padding-bottom:60px - 30px;
      }
      .detail-tab{
        font-size:14px;
        text-align: center;

        ::v-deep img{
          display: block;
          width: 100%;
          height: auto;
        }

      }
      .loading-page-wrapper{
        position: fixed;
        top:0;
        left: 0;
        bottom:0;
        right: 0;
        z-index: 2000;
      }
      .loading-page{
        width: 100%;
        height: 100%;
        background-color:rgba(255,255,255,0.9);
        .loading-ccom{
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .empty-ccom{
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .van-icon{
            color:#ed5b68;
            font-size:12px;
          }
          span{
            font-size:12px;
            color:#ed5b68;
            margin-top:10px;
            &.no-data{
              b{
                text-decoration: underline;
              }
            }
          }
        }
      }


      .title{
        padding-bottom:15px;
        border-bottom:1px solid #dadada;
      }
      .messageDialog{
        padding:25px 21px;
        .message{
          text-align: left;
          font-size: 16px;
          color:#000000;
        }
        .downBtn{
          text-align: center;
          .van-button{
            width: 195px;
            height: 30px;
            background-color:#ed5b68;
            color:#fff;
            font-size:14px;
            margin-top:30px;
          }
        }
      }
      .vanLoginDialog{
        padding:0;
        transform: translateX(-50%) translateY(-50%);
      }
      .login-dialog{
        padding:0;
        padding-top:15px;
        position: relative;
        .iconfont{
          position: absolute;
          font-size:25px;
          top:10px;
          right: 10px;
        }
        .form{
          margin-top:36px;
          .tips{
            font-size:12px;
            color:#999999;
            text-align: center;
            margin-top:10px;
            margin-bottom:9px;
          }
          .login-footer{
            width: 100%;
            display: flex;
            flex-direction: row;
            text-align: center;
            background-color: #ff536a;
            justify-content: center !important;
            border: 1px solid #ff536a;
            .van-button{
              width: 100%;
              height: 48px;
              font-size: 17px;
              background-color:#ff536a;
              color:#fff;
              display: block;
              position: relative;
              border-radius: 0;
            }
          }

        }
      }
      .download-head{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding:0 13px;
        height: 48px;
        img{
          width: 126px;
        }
        .download-button{
          height: 25px;
          padding:0 20px;
          font-size: 12px;
          color:#fff;
          border-width: 0;
        }
      }
      .main-content{
        position: relative;
        background-color:#fff;
        padding-top:18px;
        border-radius: 20px;
        width: 100%;
        top:-30px;

        .lesson-meta{
          text-align: left;
          padding:0 10px;

          .lesson-meta-inner{
            padding-bottom:15px;
            border-bottom:1px solid #e1e1e1;
          }
          .name{
            font-size: 17px;
            color:#333333;
          }
          .time-price{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top:3PX;
            .time{
              font-size:12px;
              color:#999999;
            }
            .free{
              color:#ff0000;
              font-size:17px;
              margin-right: 15px;
            }
            .topprice{

            .newPrice{
                font-size: 15px;
                color:#ef5e6a;
              }
              .oldPrice{
                font-size: 12px;
                color:#999999;
                text-decoration: line-through;
              }

            }
          }
          .lesson-label{
            margin-top:14px;
            display: flex;
            span{
              margin-right: 15px;
              color:#e85966;
              font-size: 12px;
              &:last-child{
                margin-right: 0;
              }
            }
          }
        }
        .teacher-info{
          text-align: left;
          margin-top:15px;
          padding:0 10px;
          .teacher-info-inner{
            padding-bottom:16px;
            border-bottom:1px solid #e1e1e1;
          }
          .teacher-label{
            font-size:17px;
            color:#333333;
          }
          .teacher-detail {
            margin-top:20px;
            display: flex;

            .teacher-avatar{
              display: flex;
              align-items: center;
              flex-direction: column;
              margin-right:15px;
              img{
                width: 70px;
                height: 70px;
                border-radius: 70px;
              }
              span{
                font-size: 15px;
                color: #051a35;
                margin-top:9px;
              }
              .upcounts{
                font-size:12px;
                color:#999999;
                margin-top:10px;
                display: flex;
                align-items: center;
                .iconfont{
                  font-size:25px;
                }
                span{
                  margin-top:0;
                  font-size:11px;
                  color:#999999;
                }
              }
            }
            .teacher-desc{
              font-size:12px;
              color:#666666;
              line-height: 18px;
              span{
                color: #ed5b68;
              }
            }
          }

        }
        .van-tabs{
          margin-top:5px;
          ::v-deep .van-tabs__content{
            background-color:#f9f9f9;
          }

        }
        .gridant{
            background-image:linear-gradient(to bottom,#e7e7e7 0%,#f9f9f9 100%);
            height: 25px;
          }
      }
      .bottom-button{
        width: 100%;
        height: 60px;
        position: fixed;
        z-index: 100;
        bottom: 0;
        left: 0;
        display: flex;
        border-top:1px solid #f0f0f0;
        .button-price{
          width: 130px;
          height: 100%;
          background-color:#fff;
          display: flex;
          justify-content: center;
          align-items: center;
          .price{
            .newPrice{
              font-size: 15px;
              color:#ef5e6a;
            }
            .oldPrice{
              font-size: 12px;
              color:#999999;
              text-decoration: line-through;
            }
          }
          .free{
            color:#ef5e6a;
            font-size: 15px;
          }
        }
        .button-enter{
          width: calc(100% - 130px);
          height: 100%;
          background-color:#fe7172;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          flex-direction: column;
          color:#fff;
        }
      }
    }
</style>

<style lang="scss">
  .login-dialog .login-content {
  padding: 17px 0 50px 0;
  width: 100%;
}

.login-dialog .van-cell {
  overflow: visible !important;
}

.login-dialog .van-cell__value {
  overflow: visible !important;
}

.login-dialog.verify.chrome .van-cell--center {
  transform: unset !important;
  position: fixed !important;
}


.login-dialog .input {
  border-bottom: 1px solid #dadada;
}

.login-dialog .verify .van-button--small {
  color: #ff536a;
  font-size: inherit;
}

.login-dialog .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
  border-width: 0 !important;
}
</style>
